/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Videos_HintInputs */

const cs_projects_videos_hint = /** @type {(inputs: Projects_Videos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen MP4 nebo MOV. Sreality přijímá binární soubor (ne URL).`)
};

const en_projects_videos_hint = /** @type {(inputs: Projects_Videos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP4 or MOV only. Sreality receives the binary file (not a URL).`)
};

/**
* | output |
* | --- |
* | "MP4 or MOV only. Sreality receives the binary file (not a URL)." |
*
* @param {Projects_Videos_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_videos_hint = /** @type {((inputs?: Projects_Videos_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Videos_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_videos_hint(inputs)
	return cs_projects_videos_hint(inputs)
});